import type { App } from 'vue'
import ja from '@/locales/ja'

declare const defaultLocale: string | undefined

const messages = { ja }
const locale = defaultLocale || 'ja'

const resolveMessage = (path: string): string => {
  const dictionary = messages[locale] || messages.ja
  const value = path.split('.').reduce<any>((current, key) => current?.[key], dictionary)
  return typeof value === 'string' ? value : path
}

export const translate = (
  path: string,
  parameters: Record<string, string | number> = {}
): string =>
  Object.entries(parameters).reduce(
    (message, [key, value]) =>
      message.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value)),
    resolveMessage(path)
  )

export default {
  install(app: App) {
    app.config.globalProperties.$t = translate
  }
}
